export const COMMERCIAL_PRODUCT_INFO = {
    // ── API ───────────────────────────────────────────────────────────────────
    'API|STRESS COAT™': {
        directions: `Add 5 mL per 10 gal (standard) using the dosing cap; double to 10 mL/10 gal to replace slime coat or repair damaged skin/fins.`,
        frequency: `Every time tap water is added; healing dose as needed.`,
        prep: `None — can be added to tap water before it goes in the tank.`,
        warnings: `Untreated chlorine/chloramines damage gills and can kill fish.`,
        targetRange: `Works instantly; tissue healing typically within a week.`,
        sourceUrl: `https://www.apifishcare.com/products/api-stress-coat-aquarium-water-conditioner`,
    },
    'API|AQUA ESSENTIAL™': {
        directions: `5 mL per 50 gal to dechlorinate tap water; increase to 5 mL per 10 gal when tests show elevated ammonia/nitrite/nitrate.`,
        frequency: `Whenever adding tap water; higher rate during nutrient spikes.`,
        prep: `Use the dosing cap; treat tap water before adding to tank.`,
        warnings: `Safe with other aquatic life. (The previous "removes 1 ppm ammonia / 3 ppm chlorine / 1.5 ppm chloramine" claim is not on the API label — removed.)`,
        sourceUrl: `https://www.apifishcare.com/products/api-aqua-essential-water-conditioner`,
    },
    'API|pH UP® & pH DOWN®': {
        directions: `Add gradually to reach target pH; test before dosing and re-dose when pH drifts >0.2 units. (API does not publish a fixed drops-per-gallon rate online; the app's 2 drops/gal is a conservative starting increment — verify against the physical label.)`,
        frequency: `As needed; test pH weekly.`,
        prep: `Test current pH first; add slowly over days for large changes.`,
        warnings: `Rapid pH swings stress fish.`,
        targetRange: `Community tropical 7.0; goldfish/livebearers 7.5; Amazonian species 6.5–6.8.`,
        sourceUrl: `https://www.apifishcare.com/product/ph-up/`,
    },
    'API|PROPER PH® Series (6.5, 7.0, 7.5, 8.2)': {
        directions: `Shake well; add 1 scoop per 10 gal; pre-dissolve in a cup of aquarium water for best results; re-dose when pH shifts >0.2 units.`,
        frequency: `At setup, water changes, and when pH drifts; test weekly.`,
        prep: `Pre-dissolve in aquarium water before adding.`,
        warnings: `6.5/7.0/7.5 not for planted tanks; 8.2 needs African Cichlid Salt in soft water or pH can overshoot.`,
        targetRange: `Holds pH at 6.5 / 7.0 / 7.5 / 8.2 respectively.`,
        sourceUrl: `https://www.apifishcare.com/product/proper-ph-8-2/`,
    },
    'API|TAP WATER CONDITIONER™': {
        directions: `1 mL per 10 gal to remove chlorine/heavy metals; 5 mL per 30 gal to neutralize chloramines.`,
        frequency: `Every time tap water is added.`,
        prep: `Use the dosing cap; treat tap water before adding fish.`,
        warnings: `Very concentrated — don't overdose. Chlorine/chloramine destroy gill tissue.`,
        sourceUrl: `https://www.apifishcare.com/product/tap-water-conditioner/`,
    },
    'API|AMMO LOCK®': {
        directions: `5 mL per 10 gal; dose every 2 days until ammonia is undetectable.`,
        frequency: `Every 2 days until ammonia reads zero.`,
        prep: `Partial water change first if ammonia is positive; keep aeration on.`,
        warnings: `Tank may still test positive for ammonia after dosing (it's bound, not removed) until the biofilter clears it.`,
        targetRange: `Dose until zero; address filter/feeding if still high after 7 days.`,
        sourceUrl: `https://www.apifishcare.com/products/api-ammo-lock-freshwater-and-saltwater-aquarium-ammonia-detoxifier`,
    },
    'API|STRESS ZYME™': {
        directions: `Shake well; 5 mL per 10 gal weekly; double dose at startup and for 2 weeks after.`,
        frequency: `Weekly; double at startup.`,
        prep: `Shake well.`,
        targetRange: `Ongoing weekly use.`,
        sourceUrl: `https://www.apifishcare.com/products/api-stress-zyme-freshwater-and-saltwater-aquarium-cleaning-solution`,
    },
    'API|QUICK START™': {
        directions: `Shake well; 10 mL per 10 gal (freshwater); double (20 mL/10 gal) for saltwater.`,
        frequency: `At setup and after anything that disrupts bacteria (water change, new fish, meds, media change).`,
        prep: `Shake well; don't freeze.`,
        warnings: `Don't freeze.`,
        targetRange: `Starts the cycle immediately.`,
        sourceUrl: `https://www.apifishcare.com/products/api-quick-start-freshwater-and-saltwater-aquarium-nitrifying-bacteria`,
    },
    'API|ACCU-CLEAR™': {
        directions: `1 mL per 10 gal; clears within hours; repeat after 24 h if needed.`,
        frequency: `As needed; weekly for routine maintenance.`,
        warnings: `Freshwater only.`,
        targetRange: `Clears within several hours.`,
        sourceUrl: `https://www.apifishcare.com/product/accu-clear/`,
    },
    'API|ALGAEFIX®': {
        directions: `1 mL per 10 gal; repeat every 3 days until controlled; weekly for prevention.`,
        frequency: `Every 3 days (treatment); weekly (maintenance).`,
        prep: `Siphon/scrape dead algae after treatment.`,
        warnings: `⚠ Do NOT overdose. NOT for use with freshwater crustaceans (shrimp, crabs, lobsters).`,
        targetRange: `Every 3 days until controlled.`,
        sourceUrl: `https://www.apifishcare.com/product/algaefix/`,
    },
    'API|LEAF ZONE®': {
        directions: `5 mL per 10 gal weekly.`,
        frequency: `Weekly.`,
        warnings: `Freshwater fish/plant tanks only.`,
        targetRange: `Ongoing weekly use.`,
        sourceUrl: `https://www.apifishcare.com/product/leaf-zone/`,
    },
    'API|CO2 BOOSTER™': {
        directions: `1 mL per 10 gal once daily (or 5 mL/50 gal).`,
        frequency: `Daily.`,
        prep: `Use dosing cap.`,
        warnings: `Freshwater only.`,
        targetRange: `Daily ongoing.`,
        sourceUrl: `https://www.apifishcare.com/products/api-co2-booster-freshwater-aquarium-plant-treatment`,
    },
    'API|ROOT TABS™': {
        directions: `Push tabs ≥1 inch into substrate at the plant base; add monthly. (API publishes "monthly" but not a per-area rate; the app's 1 tab/30 in² is a common rule of thumb — not on the official page.)`,
        frequency: `Monthly.`,
        prep: `Bury at least 1 inch deep.`,
        warnings: `Safe with tropical fish (not stated invert-safe like Easy Root Tabs).`,
        targetRange: `Monthly.`,
        sourceUrl: `https://www.apifishcare.com/product/root-tabs/`,
    },
    'API|MELAFIX™': {
        directions: `Shake well; remove activated carbon; 5 mL per 10 gal daily for 7 days, then 25% water change (3 days for new fish).`,
        frequency: `Daily ×7 (diseased) or ×3 (new fish).`,
        prep: `Remove carbon; shake.`,
        warnings: `⚠ Prop 65 (beta-myrcene). Won't harm biofilter, pH, or water color.`,
        targetRange: `7-day course.`,
        sourceUrl: `https://www.apifishcare.com/products/api-melafix-freshwater-fish-bacterial-infection-remedy`,
    },
    'API|PIMAFIX™': {
        directions: `Shake well; remove carbon; 5 mL per 10 gal daily ×7, then 25% water change; in saltwater turn off skimmer/UV during treatment.`,
        frequency: `Daily ×7.`,
        prep: `Shake; remove carbon; saltwater — skimmer/UV off.`,
        warnings: `⚠ Prop 65 (beta-myrcene). Safe for inverts/corals/anemones; may haze saltwater without filtration.`,
        targetRange: `7-day course.`,
        sourceUrl: `https://www.apifishcare.com/products/api-pimafix-antifungal-freshwater-and-saltwater-fish-remedy`,
    },
    'API|GENERAL CURE™': {
        directions: `Remove carbon, keep aeration; 1 packet per 10 gal; repeat after 48 h; wait 48 h more then 25% water change.`,
        frequency: `2 doses over 4 days.`,
        prep: `Remove carbon; keep aeration.`,
        warnings: `⚠ Prop 65 (metronidazole). Plant safe.`,
        targetRange: `Full course = 2 doses + day-5 water change.`,
        sourceUrl: `https://www.apifishcare.com/products/api-general-cure-powder-packets`,
    },
    'API|SUPER ICK CURE™': {
        directions: `Remove carbon, keep aeration; 5 mL (1 tsp) per 5 gal; repeat after 48 h; wait 48 h more then 25% water change; raising temp to 82°F speeds it.`,
        frequency: `2 doses over 4 days.`,
        prep: `Remove carbon; aeration on.`,
        warnings: `⚠ Prop 65 (nitrofurazone). Half dose for scaleless fish. NOT for reef/invert tanks; will tint water.`,
        targetRange: `2-dose course.`,
        sourceUrl: `https://www.apifishcare.com/products/api-liquid-super-ick-cure`,
    },
    // ── Aqueon ─────────────────────────────────────────────────────────────────
    'Aqueon|Water Conditioner': {
        directions: `5 mL (1 tsp) per 10 gal; safe to double for high chloramine or stressed fish.`,
        frequency: `Every time tap water is added.`,
        sourceUrl: `https://www.aqueon.com/products/water-care/water-conditioners`,
    },
    'Aqueon|Ammonia Neutralizer': {
        directions: `5 mL (1 tsp) per 10 gal; repeat after 24 h if needed.`,
        frequency: `As needed; repeat at 24 h.`,
        prep: `Reduce ammonia sources (overfeeding/overcrowding).`,
        targetRange: `Repeat until ammonia is undetectable.`,
        sourceUrl: `https://www.aqueon.com/products/water-care/ammonia-neutralizers`,
    },
    'Aqueon|Water Clarifier': {
        directions: `5 mL (1 tsp) per 10 gal; after clearing, replace filter cartridge; wait 24 h then do a partial water change.`,
        frequency: `As needed; 24 h between doses.`,
        prep: `Replace filter cartridge after clearing.`,
        warnings: `Freshwater only.`,
        targetRange: `Clears after dosing.`,
        sourceUrl: `https://www.aqueon.com/products/water-care/water-clarifiers`,
    },
    'Aqueon|PURE Bacteria Supplement': {
        directions: `1 ball per 10 gal weekly; 2 balls per 10 gal for new setups.`,
        frequency: `Weekly; double at setup.`,
        prep: `Drop into a filtered tank; works best with active filtration.`,
        warnings: `Doesn't replace water changes; not for human consumption.`,
        targetRange: `Ongoing weekly; freshwater only.`,
        sourceUrl: `https://www.aqueon.com/products/water-care/pure-aquarium-gel-balls`,
    },
    'Aqueon|Aquarium Plant Food': {
        directions: `10 mL (2 tsp) per 10 gal weekly.`,
        frequency: `Weekly.`,
        prep: `Ensure proper lighting.`,
        warnings: `Don't use copper-containing ferts with snails/dwarf shrimp.`,
        targetRange: `Ongoing weekly.`,
        sourceUrl: `https://www.aqueon.com/products/water-care/plant-foods`,
    },
    // ── Aquarium Co-Op ─────────────────────────────────────────────────────────
    'Aquarium Co-Op|Easy Green All-in-One Fertilizer': {
        directions: `1 mL (1 pump) per 10 gal per dose; low light 1×/wk, medium 2×/wk, high 3×/wk.`,
        frequency: `1–3×/week by light level.`,
        warnings: `Excess fert feeds algae.`,
        targetRange: `Ongoing; adjust to plant/nitrate response.`,
        sourceUrl: `https://www.aquariumcoop.com/products/easy-green-all-in-one-fertilizer`,
    },
    'Aquarium Co-Op|Easy Iron': {
        directions: `1 mL (1 pump) per 10 gal, 1–3×/week; start low and increase after 2 weeks.`,
        frequency: `1–3×/week.`,
        prep: `None (caps now replace pump heads).`,
        warnings: `Excess iron can fuel hair algae.`,
        targetRange: `Iron ~0.1–0.5 ppm; ~0.26 ppm per 1 mL/10 gal.`,
        sourceUrl: `https://www.aquariumcoop.com/products/easy-iron`,
    },
    'Aquarium Co-Op|Easy Potassium': {
        directions: `1 pump (~1–1.3 mL) per 10 gal, 1–3×/week.`,
        frequency: `1–3×/week as needed.`,
        warnings: `Won't repair damaged leaves, prevents new holes.`,
        targetRange: `~2 ppm K per 1 mL/10 gal.`,
        sourceUrl: `https://www.aquariumcoop.com/products/easy-potassium`,
    },
    'Aquarium Co-Op|Easy Root Tabs': {
        directions: `Push ≥1 inch into substrate under the plant; replenish monthly or as needed.`,
        frequency: `Monthly.`,
        prep: `Bury at least 1 inch to avoid releasing into the water column.`,
        warnings: `Safe even if contents release; best paired with Easy Green.`,
        targetRange: `Monthly; replenish when plants yellow/melt.`,
        sourceUrl: `https://www.aquariumcoop.com/products/easy-root-tabs`,
    },
    'Aquarium Co-Op|Easy Dechlorinator': {
        directions: `1 mL per 10 gal of new water (use measuring cap); for <10 gal, 2 drops/gal.`,
        frequency: `Every water change.`,
        prep: `Dose the new-water volume, not the whole tank.`,
        sourceUrl: `https://www.aquariumcoop.com/products/aquarium-co-op-easy-dechlorinator`,
    },
    // ── Brightwell Aquatics ────────────────────────────────────────────────────
    'Brightwell Aquatics|MicroBacter7': {
        directions: `Mix dose into 250 mL tank water first; add to filter intake. New/high-nutrient: 5 mL/25 gal daily ×2 weeks. Maintenance: 5 mL/50 gal weekly (or 1 mL/25 gal daily).`,
        frequency: `Daily ×2 weeks (new); weekly maintenance.`,
        prep: `Shake; pre-mix in 250 mL tank water. Use within 1 year.`,
        warnings: `Turn off skimmer/UV for 4 h after dosing; don't add to pump intakes; not with QuikCycl.`,
        targetRange: `Max 1 mL/25 gal/day.`,
        sourceUrl: `https://www.brightwellaquatics.com/products/microbacter7t.php`,
    },
    'Brightwell Aquatics|Reef Code A & B': {
        directions: `Shake; 5 mL/25 gal every other day (maintenance), or up to 5 mL/10 gal daily when building. Dose into high flow; ≥60 sec between A and B; never mix.`,
        frequency: `Every other day (maintenance); daily (building).`,
        prep: `Shake; set Mg 1290–1320 ppm before starting. Powder B: dissolve 480 g per gallon RO/DI.`,
        warnings: `Instant precipitation if A+B mixed. Allow time (60 s up to 15–20 min) between A and B.`,
        targetRange: `Ca 412–450 ppm, Alk 7–12 dKH, Mg 1290–1320 ppm.`,
        sourceUrl: `https://www.brightwellaquatics.com/products/reefcodeat.php`,
    },
    'Brightwell Aquatics|Magnesion': {
        directions: `Liquid: 5 mL/20 gal every other day; max 10 mL/20 gal/day when building. Powder: dissolve 2.5 g (~¾ tsp)/20 gal in 16 fl oz RO/DI first.`,
        frequency: `Every other day; daily for stability/building.`,
        prep: `Shake (liquid); fully dissolve powder before dosing.`,
        warnings: `Don't raise Mg >100 ppm/day; don't add undissolved powder to the tank.`,
        targetRange: `Mg 1290–1320 ppm.`,
        sourceUrl: `https://www.brightwellaquatics.com/products/magnesion_t.php`,
    },
    'Brightwell Aquatics|FlorinMulti': {
        directions: `Shake; 5 mL/50 gal weekly for 3–5 weeks, then adjust; daily micro-dosing (~6 drops/50 gal/day) preferred long-term.`,
        frequency: `Weekly initially; daily micro-dosing for established tanks.`,
        prep: `Shake.`,
        warnings: `Contains trace copper — caution in shrimp tanks.`,
        targetRange: `Adjust to plant health.`,
        sourceUrl: `https://www.brightwellaquatics.com/products/florinmultit.php`,
    },
    'Brightwell Aquatics|FlorinAxis': {
        directions: `Shake; 5 mL/50 gal weekly for 3–5 weeks, then adjust; daily micro-dosing (~6 drops/50 gal/day) preferred.`,
        frequency: `Weekly initially; daily preferred.`,
        prep: `Shake.`,
        warnings: `Standard precautions.`,
        targetRange: `As needed for carbon supplementation.`,
        sourceUrl: `https://brightwelldirect.com/pages/florinaxis`,
    },
    // ── Bulk Reef Supply (BRS) ─────────────────────────────────────────────────
    'Bulk Reef Supply (BRS)|Alkalinity Supplements': {
        directions: `Dissolve dry in RO/DI to make 1 gal (soda ash 2⅓ cups/gal; bicarb 1 cup + 2 tbsp/gal). Dose slowly into high flow; never add dry powder to the tank.`,
        frequency: `Daily; split if raising >1.4 dKH/day.`,
        prep: `Fully dissolve in RO/DI (bicarb may need up to 24 h).`,
        warnings: `Raises pH temporarily — dose slowly. Never raise >1.4 dKH/day. Never mix Ca + alk solutions.`,
        targetRange: `7–10 dKH (~9 dKH recommended).`,
        sourceUrl: `https://www.bulkreefsupply.com/content/post/brs-pharma-soda-ash-sodium-carbonate-mixing-dosing-instructions`,
    },
    'Bulk Reef Supply (BRS)|Calcium Supplements': {
        directions: `Dissolve dry CaCl₂ in RO/DI (2.5 cups/gal). Dose slowly into a powerhead stream. Don't raise Ca >50 ppm/day.`,
        frequency: `Daily/as needed; split if >50 ppm/day.`,
        prep: `Dissolve in RO/DI; anhydrous CaCl₂ heats up — let it cool.`,
        warnings: `Never mix Ca + alk solutions.`,
        targetRange: `380–450 ppm (~420 recommended).`,
        sourceUrl: `https://www.bulkreefsupply.com/content/post/brs-two-part-dosing-calculator`,
    },
    'Bulk Reef Supply (BRS)|Magnesium Supplements': {
        directions: `Dissolve dry blend in RO/DI: 7¼ cups MgCl₂ + ¾ cup MgSO₄ per gal. Dose into high flow.`,
        frequency: `Daily/as needed; split if >100 ppm/day.`,
        prep: `Fully dissolve (may need overnight).`,
        warnings: `Don't raise Mg >100 ppm/day.`,
        targetRange: `1200–1350 ppm.`,
        sourceUrl: `https://www.bulkreefsupply.com/magnesium-mix-instructions`,
    },
    'Bulk Reef Supply (BRS)|GFO Media': {
        directions: `Start 1 tbsp per 4 gal; run in an upflow reactor (barely tumbling) or mesh bag in high flow; rinse first.`,
        frequency: `Replace every 4–8 weeks or when PO4 rises; test weekly.`,
        prep: `Rinse in RO/DI; reactor preferred.`,
        warnings: `Don't drop PO4 too fast (coral stress); don't let GFO tumble vigorously.`,
        targetRange: `PO4 0.01–0.05 ppm.`,
        sourceUrl: `https://www.bulkreefsupply.com/content/post/Granular-Ferric-Oxide-GFO-Instructions`,
    },
    'Bulk Reef Supply (BRS)|ROX 0.8 Carbon': {
        directions: `1 tbsp per 10 gal; hold stationary in a reactor (between sponges) or high-flow bag; rinse first.`,
        frequency: `Replace every 1–2 weeks; never >14 days.`,
        prep: `Rinse; keep media from tumbling.`,
        warnings: `Exhausted carbon can leach back — no carbon is better than old carbon.`,
        targetRange: `1–2 week schedule.`,
        sourceUrl: `https://www.bulkreefsupply.com/content/post/brs-rox-0-8-aquarium-carbon`,
    },
    // ── E.S.V. ─────────────────────────────────────────────────────────────────
    'E.S.V.|B-Ionic 2-Part': {
        directions: `Start 1 mL of each per 4 gal/day; dose each separately ≥1 hour apart; test daily. Halve to 1 mL/8 gal if also running kalkwasser. (2-gal concentrate: fill to line with RO/DI first.)`,
        frequency: `Daily; never >1 mL/gal of either component per 24 h.`,
        prep: `Top off concentrate with RO/DI; dose into moderate/high flow, components ≥1 h apart.`,
        warnings: `Never dose both at once or mix them. Never let pH exceed 8.45.`,
        targetRange: `Alk 3.0–3.75 meq/L (8.4–10.5 dKH); Ca 400–450 ppm.`,
        sourceUrl: `https://www.esvaquarium.com`,
    },
    'E.S.V.|Magnesium Chloride': {
        directions: `1.5 mL per gal/day until target reached, then maintain by consumption.`,
        frequency: `Daily until target; then as needed.`,
        prep: `Dose into high flow.`,
        warnings: `Don't raise Mg >100 ppm/day; gloves/eye protection.`,
        targetRange: `1200–1350 ppm.`,
        sourceUrl: `https://www.saltwateraquarium.com/b-ionic-magnesium-1-gallon-esv/`,
    },
    // ── Fluval ─────────────────────────────────────────────────────────────────
    'Fluval|Water Conditioner': {
        directions: `Add to replacement water before it goes in; ~5 mL per pump; ~1 mL/gal (≈5 mL/5 gal). Double for injured fish.`,
        frequency: `Every water change.`,
        prep: `Add to replacement water; wait a few minutes before adding Cycle/Waste Control.`,
        warnings: `Avoid high heat.`,
        sourceUrl: `https://fluvalaquatics.com/us/shop/product/aqua-plus-water-conditioner`,
    },
    'Fluval|Biological Enhancer': {
        directions: `Shake well; New Day 1: 25 mL/10 gal; Day 2 & 3: 10 mL/10 gal; Maintenance: 5 mL/10 gal weekly; adding fish/after meds: 10 mL/10 gal.`,
        frequency: `Daily ×3 (new), then weekly.`,
        prep: `Shake; dechlorinate first.`,
        warnings: `Avoid high heat; cannot be overdosed.`,
        targetRange: `3-day startup; weekly maintenance.`,
        sourceUrl: `https://fluvalaquatics.com/us/shop/product/cycle-biological-enhancer`,
    },
    'Fluval|Biological Cleaner': {
        directions: `Add after dechlorinating; 5 mL per 10 gal weekly (new setups + maintenance); 10 mL per 10 gal for heavy initial waste until controlled.`,
        frequency: `Weekly.`,
        prep: `Dechlorinate new water first.`,
        warnings: `Rapid waste breakdown can briefly raise ammonia — pair with Cycle. Avoid high heat; cannot be overdosed.`,
        targetRange: `Weekly ongoing.`,
        sourceUrl: `https://fluvalaquatics.com/us/faqs/waste-control-biological-aquarium-cleaner`,
    },
    'Fluval|Plant Gro+': {
        directions: `Shake; 5 mL per 15 gal weekly; keep iron ~0.3 mg/L (use an iron test kit).`,
        frequency: `Weekly.`,
        prep: `Shake; monitor iron.`,
        warnings: `Freshwater only.`,
        targetRange: `Iron ~0.15–0.3 mg/L.`,
        sourceUrl: `https://fluvalaquatics.com/us/shop/product/plant-gro`,
    },
    // ── Fritz Aquatics ─────────────────────────────────────────────────────────
    'Fritz Aquatics|FritzGuard': {
        directions: `5 mL per 10 gal; add to tap water before it goes in; safe up to 5× in high-chlorine areas.`,
        frequency: `Every water change.`,
        prep: `Treat tap water first.`,
        warnings: `Turn off skimmer 6–24 h after dosing (foaming). NOT for axolotls. Don't combine with Ich-X.`,
        sourceUrl: `https://fritzaquatics.com/products/fritzguard`,
    },
    'Fritz Aquatics|Fritz A.C.C.R.': {
        directions: `5 mL (1 tsp) per 10 gal; treat tap water first; up to 5× for emergencies.`,
        frequency: `Every water change; or as emergency ammonia treatment.`,
        prep: `Treat tap water before adding.`,
        warnings: `Interferes with Nessler ammonia kits — use salicylate kits. Don't combine with Ich-X.`,
        targetRange: `Detoxifies 1 ppm ammonia per dose.`,
        sourceUrl: `https://fritzaquatics.com/products/fritz-accr-liquid`,
    },
    'Fritz Aquatics|FritzZyme 7': {
        directions: `New: 4 oz (119 mL) per 10 gal; Established: 1 oz (30 mL) per 10 gal; add directly.`,
        frequency: `Single application to cycle; reapply after disruption.`,
        prep: `Dechlorinate first; turn off UV/skimmer/ozone ≥5 days; aerate.`,
        warnings: `UV/skimmer/ozone off ≥5 days; copper/malachite green/methylene blue are lethal to bacteria. Don't freeze.`,
        targetRange: `77–86°F, pH 7.3–8.0, KH ≥4.5; done when NH3/NO2 = 0.`,
        sourceUrl: `https://fritzaquatics.com/products/fritzzyme-7-freshwater`,
    },
    'Fritz Aquatics|FritzZyme 9': {
        directions: `New: 4 oz (119 mL) per 5 gal (double the per-gallon rate of FritzZyme 7); Established: 1 oz per 5 gal; add directly.`,
        frequency: `Single application; reapply after disruption.`,
        prep: `Dechlorinate; UV/skimmer/rollers off ≥5 days.`,
        warnings: `Same as 7; copper lethal; don't freeze.`,
        targetRange: `77–86°F, pH 7.3–8.0, salinity 15–40 ppt, KH ≥4.5.`,
        sourceUrl: `https://fritzaquatics.com/products/fritzzyme-9-saltwater`,
    },
    'Fritz Aquatics|TurboStart 700': {
        directions: `700 (FW): 1 oz (29 mL) per 50 gal. Shake; up to 5× to accelerate.`,
        frequency: `Single application; reapply as needed.`,
        prep: `Dechlorinate; UV/skimmer off ≥5 days; store refrigerated (~6 mo).`,
        warnings: `UV kills bacteria; copper lethal; don't freeze.`,
        targetRange: `77–86°F, pH 7.3–8.0, KH ≥4.5; done when NH3/NO2 = 0.`,
        sourceUrl: `https://fritzaquatics.com/products/fritzzyme-turbostart-700-freshwater`,
    },
    'Fritz Aquatics|TurboStart 900': {
        directions: `900 (SW): 1 oz per 25 gal. Shake; up to 5× to accelerate.`,
        frequency: `Single application; reapply as needed.`,
        prep: `Dechlorinate; UV/skimmer off ≥5 days; store refrigerated (~4 mo).`,
        warnings: `UV kills bacteria; copper lethal; don't freeze.`,
        targetRange: `77–86°F, pH 7.3–8.0, KH ≥4.5; done when NH3/NO2 = 0.`,
        sourceUrl: `https://fritzaquatics.com/products/fritzzyme-turbostart-900-saltwater`,
    },
    'Fritz Aquatics|Coppersafe®': {
        directions: `5 mL per 4 gal; one dose maintains ~2 ppm; test copper every 2–3 days.`,
        frequency: `One initial dose; maintain for a 30-day course.`,
        prep: `Remove carbon/ion-exchange resins; use a chelated-copper test kit.`,
        warnings: `⚠ NOT safe for inverts/corals/live rock/reef — fish-only/quarantine only. Scaleless/sensitive fish may need reduced dose.`,
        targetRange: `1.5–2.0 ppm chelated copper for 30 days.`,
        sourceUrl: `https://fritzaquatics.com/products/mardel-coppersafe`,
    },
    // ── General ────────────────────────────────────────────────────────────────
    'General|Kalkwasser (Limewater)': {
        directions: `Dissolve calcium hydroxide in RO/DI (≈1.5–2 tsp/gal), let settle, and drip only the clear solution as top-off. Best used as ATO water.`,
        frequency: `Continuous drip / ATO replacing evaporation.`,
        prep: `Dissolve in fresh (not salt) water; use only clear supernatant; keep lid tight (CO2 weakens it).`,
        warnings: `⚠ Never dose undissolved or fast — pH spikes. Don't mix with Ca/alk supplements.`,
        targetRange: `Hold pH ~8.3–8.4; volume limited by evaporation.`,
        sourceUrl: `https://www.reef2reef.com/threads/reef-chemistry-question-of-the-day-157-limewater-kalkwasser.224834/`,
    },
    // ── Hikari ─────────────────────────────────────────────────────────────────
    'Hikari|Ich-X': {
        directions: `Large water change before first dose (sulfate-free conditioner); remove carbon; 5 mL (1 tsp) per 10 gal; repeat with a pre-dose water change ≥ every 24 h; continue 3 days past last visible spot.`,
        frequency: `At least every 24 h (no more than every 8 h).`,
        prep: `Water change + remove carbon before dosing; don't stop filtration; QT tank preferred.`,
        warnings: `⚠ Don't overdose; DON'T FREEZE (becomes lethal). Don't use sulfur/sulfinate conditioners (Prime, Fluval AquaPlus).`,
        targetRange: `Continue 3 days after spots clear.`,
        sourceUrl: `https://www.hikariusa.com/water_quality_folder/ich_x.html`,
    },
    'Hikari|PraziPro': {
        directions: `≥30% water change first (sulfate-free conditioner); remove carbon; stop skimmer/UV; shake; 5 mL (1 tsp) per 20 gal; treatment lasts 5–7 days; repeat no more than every 3 days (up to 4 total).`,
        frequency: `One 5–7 day treatment; repeat ≤ every 3 days.`,
        prep: `Water change; remove carbon; skimmer/UV off; shake.`,
        warnings: `⚠ Don't overdose or combine with other meds; not with feather dusters/Polycladida; may foam.`,
        targetRange: `5–7 days; up to 4 treatments (28-day parasite cycle).`,
        sourceUrl: `https://www.hikariusa.com/water_quality_folder/prazipro.html`,
    },
    'Hikari|Metro+': {
        directions: `(bath): Partial water change; 1 capful (~9.7 g) per 10 gal (~5 mg/L); retreat every 24 h after a water change for 5–7 days. (Oral: mix into food per the PDS.)`,
        frequency: `Bath daily ×5–7 days; oral ≥2×/day.`,
        prep: `Partial water change before each bath; store 40–100°F; keep water out of the bottle.`,
        warnings: `⚠ Don't overdose or combine meds; avoid inhaling powder. (A newer label cited 1 capful/20 gal — verify your physical label.)`,
        targetRange: `5–7 day bath; oral 3 days past symptom resolution.`,
        sourceUrl: `https://www.hikariusa.com/img/pds/PDS_Metro.pdf`,
    },
    // ── NilocG ─────────────────────────────────────────────────────────────────
    'NilocG|Thrive All in One': {
        directions: `1 pump (2 mL) per 10 gal, 3–5×/week.`,
        frequency: `3–5×/week.`,
        prep: `Shake; dose after water changes.`,
        warnings: `Contains copper — caution in shrimp tanks.`,
        targetRange: `Adjust to plant health/algae.`,
        sourceUrl: `https://nilocg.com/products/na-thrive`,
    },
    'NilocG|Thrive+ (High-Tech)': {
        directions: `1 pump (2 mL) per 10 gal, 1–3×/week.`,
        frequency: `1–3×/week.`,
        prep: `Shake.`,
        warnings: `Contains copper — reduce/avoid with inverts; not for low-tech tanks.`,
        targetRange: `Adjust to growth.`,
        sourceUrl: `https://nilocg.com/products/thrive-all-in-one-aquarium-fertilizer`,
    },
    'NilocG|ThriveC (Low-Tech)': {
        directions: `1 pump (1 mL) per 5 gal, 1–2×/week.`,
        frequency: `1–2×/week.`,
        prep: `Shake.`,
        warnings: `Contains some copper — caution in shrimp tanks.`,
        targetRange: `Adjust to plant/algae.`,
        sourceUrl: `https://nilocg.com/products/thrivec`,
    },
    'NilocG|ThriveS (Shrimp)': {
        directions: `1 pump (1 mL) per 5 gal, 1–3×/week.`,
        frequency: `1–3×/week.`,
        prep: `Shake.`,
        warnings: `Copper-free; verify formula if shrimp health declines.`,
        targetRange: `Adjust to plant response.`,
        sourceUrl: `https://nilocg.com/products/thrives`,
    },
    'NilocG|Enhance (Carbon)': {
        directions: `1 pump (1 mL) per 10 gal, 4–7×/week or daily; up to 5 mL/10 gal once after a large (>30%) water change.`,
        frequency: `Daily / 4–7×/week.`,
        prep: `Shake; don't pre-mix with other chemicals.`,
        warnings: `⚠ Glutaraldehyde is toxic to inverts and some plants at high dose — start low; hazardous if swallowed.`,
        targetRange: `Reduce if algae worsens or plants stress.`,
        sourceUrl: `https://nilocg.com/products/enhance`,
    },
    // ── Red Sea ────────────────────────────────────────────────────────────────
    'Red Sea|Reef Foundation System (A, B, C)': {
        directions: `Dose daily based on measured consumption via the Red Sea Reef Care calculator/MyRecipe; add to sump/high flow.`,
        frequency: `Daily, based on consumption; test 2–3×/week.`,
        prep: `Calculate daily consumption first.`,
        warnings: `Ca ≤50 ppm/day; Alk ≤1.4 dKH/day; Mg ≤100 ppm/day; never mix A and B.`,
        targetRange: `Ca 400–450, Alk 7–11 dKH, Mg 1230–1350 ppm.`,
        sourceUrl: `https://www.redseafish.com/reef-care-program/reef-foundation/`,
    },
    'Red Sea|NO3:PO4-X (NOPOX)': {
        directions: `Start 2 mL per 25 gal (100 L)/day into the sump; increase by 1 mL/100 L up to max 3 mL/100 L/day; reduce to maintenance once targets are reached.`,
        frequency: `Daily into sump/high flow.`,
        prep: `Efficient skimming required (output increases sharply).`,
        warnings: `⚠ Don't overdose — bacterial blooms can deplete oxygen. Increase gradually; don't dose onto corals.`,
        targetRange: `NO3 1–10 ppm; PO4 0.05–0.1 ppm (lower for SPS).`,
        sourceUrl: `https://www.redseafish.com/reef-care-program/reef-colors/no3po4-x/`,
    },
    'Red Sea|Reef Energy Plus': {
        directions: `Mixed reef 4 mL per 25 gal/day; SPS-dominant up to 8 mL/25 gal/day; stir into a cup of tank water, then add to sump/broadcast.`,
        frequency: `Daily (at night / when polyps extended).`,
        prep: `Skimmer off 15–30 min before/after; shake; refrigerate after opening (use within 4 weeks).`,
        warnings: `If skimmer stays on, nutrients are stripped; start at half dose.`,
        targetRange: `Adjust to coral response.`,
        sourceUrl: `https://www.redseafish.com/reef-care-program/reef-energy-plus/`,
    },
    // ── Seachem ────────────────────────────────────────────────────────────────
    'Seachem|AmGuard™': {
        directions: `5 mL per 50 gal daily/as needed; for 1 mg/L free ammonia use 5 mL per 10 gal.`,
        frequency: `Daily or as needed (every 24 h).`,
        prep: `Scale to measured ammonia; use a gas-exchange ammonia test.`,
        warnings: `Don't use above 86°F; high doses can lower O2; standard kits give false positives.`,
        targetRange: `Active up to 72 h; emergency "toxic" = 5 mL/20 gal.`,
        sourceUrl: `https://www.seachem.com/amguard.php`,
    },
    'Seachem|Clarity™': {
        directions: `5 mL per 20 gal; repeat every 24 h as needed; clears in 1–2 h.`,
        frequency: `Every 24 h until clear.`,
        prep: `Run mechanical filtration (floss) to capture flocculated particles.`,
        warnings: `Water may cloud first (normal); use ¼–½ dose in soft water.`,
        targetRange: `Clears within 1–2 h.`,
        sourceUrl: `https://www.seachem.com/clarity.php`,
    },
    'Seachem|Cupramine™': {
        directions: `1 mL (20 drops) per 10.5 gal day 1; wait 48 h, repeat. Half dose in freshwater. Final target 0.5 mg/L (0.25 FW); hold 14 days; test before redosing.`,
        frequency: `Two doses 48 h apart; maintain 14 days.`,
        prep: `Remove inverts; UV/ozone off; remove chemical filtration; no other meds/reducers.`,
        warnings: `⚠ Therapeutic 0.5 mg/L; toxic 0.8 mg/L; don't exceed 0.6. NOT reef safe. Formalin/reducers make copper 10× more toxic.`,
        targetRange: `0.5 mg/L (marine) / 0.25 (FW); 14-day course.`,
        sourceUrl: `https://www.seachem.com/cupramine.php`,
    },
    'Seachem|de*nitrate™': {
        directions: `Place where water flows through; flow ≤ 50 gal/hr; use 500 mL per 25–50 gal; rinse first.`,
        frequency: `Permanent media; pre-filter to extend life.`,
        prep: `Rinse; if NO3 >20 ppm, water-change down first.`,
        warnings: `Flow must stay ≤50 gal/hr for denitrification; use Matrix in high flow.`,
        targetRange: `Stabilizes NO3 ~4–5 ppm.`,
        sourceUrl: `https://www.seachem.com/denitrate.php`,
    },
    'Seachem|Discus Buffer®': {
        directions: `5 g per 10–20 gal daily until target reached; then monthly/with water changes. Combine with Neutral Regulator for intermediate pH.`,
        frequency: `Daily (adjust); monthly (maintain).`,
        prep: `Best in unbuffered (RO/DI) water.`,
        warnings: `Softens water — monitor GH.`,
        targetRange: `pH 5.8–6.8.`,
        sourceUrl: `https://www.seachem.com/discus-buffer.php`,
    },
    'Seachem|Equilibrium™': {
        directions: `16 g per 20 gal raises GH ~1 meq/L (3 dH); dissolve in 1 L water first (hazes then clears).`,
        frequency: `At setup and water changes only (not top-off).`,
        prep: `Dissolve in 1 L first; dose to new-water volume.`,
        warnings: `Don't use for evaporation top-off.`,
        targetRange: `GH 1–2 meq/L (3–6 dH).`,
        sourceUrl: `https://seachem.zendesk.com/hc/en-us/articles/115000196774`,
    },
    'Seachem|Flourish®': {
        directions: `5 mL per 60 gal 1–2×/week; refrigerate 3 months after opening.`,
        frequency: `1–2×/week.`,
        warnings: `Daily dosing can fuel algae.`,
        targetRange: `Dose by volume, not a nutrient target.`,
        sourceUrl: `https://seachem.zendesk.com/hc/en-us/articles/115000194653`,
    },
    'Seachem|Flourish Advance®': {
        directions: `Shake; 5 mL per 20 gal daily; daily for 10–14 days then every other day.`,
        frequency: `Daily, then every other day.`,
        prep: `Shake.`,
        warnings: `Sour odor is normal; shrimp safe.`,
        targetRange: `Root growth in first 10–14 days.`,
        sourceUrl: `https://www.seachem.com/flourish-advance.php`,
    },
    'Seachem|Flourish Excel™': {
        directions: `Initial/after >40% water change: 5 mL per 10 gal; maintenance 5 mL per 50 gal daily/every other day.`,
        frequency: `Daily or every other day.`,
        prep: `Dose during photoperiod.`,
        warnings: `Anacharis sensitive (every other day); overdose can melt Vallisneria; not a spot algicide.`,
        targetRange: `Carbon lasts ~24 h.`,
        sourceUrl: `https://www.seachem.com/flourish-excel.php`,
    },
    'Seachem|Flourish Iron™': {
        directions: `5 mL per 50 gal or as needed to hold ~0.10 mg/L iron; test within 30 min (rapid uptake).`,
        frequency: `Daily (iron depletes fast).`,
        warnings: `Dose Iron daily and Flourish weekly separately to avoid algae.`,
        targetRange: `~0.10 mg/L iron.`,
        sourceUrl: `https://seachem.zendesk.com/hc/en-us/articles/115000239553`,
    },
    'Seachem|Flourish Nitrogen™': {
        directions: `2.5 mL (½ cap) per 20 gal 1–2×/week; each dose ≈ +1 mg/L nitrate equivalent.`,
        frequency: `1–2×/week.`,
        warnings: `Half the N is urea-bound and won't show on a nitrate test immediately.`,
        targetRange: `Nitrogen (as nitrate) 10–20 mg/L.`,
        sourceUrl: `https://www.seachem.com/downloads/charts/Plant-Dose-Chart.pdf`,
    },
    'Seachem|Flourish Phosphorus™': {
        directions: `2.5 mL (½ cap) per 20 gal 1–2×/week as needed.`,
        frequency: `1–2×/week.`,
        warnings: `Dose only for confirmed deficiency; excess feeds algae; water changes ≤30%.`,
        targetRange: `Phosphate ~0.5–1 mg/L.`,
        sourceUrl: `https://seachem.zendesk.com/hc/en-us/articles/115000948714`,
    },
    'Seachem|Flourish Potassium™': {
        directions: `5 mL per 30 gal 1–2×/week; each dose ≈ +2 mg/L K.`,
        frequency: `1–2×/week.`,
        warnings: `Deficiency = yellowing older leaves; shrimp safe.`,
        targetRange: `K 8–15 mg/L (plants).`,
        sourceUrl: `https://www.seachem.com/downloads/charts/Plant-Dose-Chart.pdf`,
    },
    'Seachem|Flourish Trace™': {
        directions: `5 mL per 20 gal twice a week (alternate days with Flourish).`,
        frequency: `1–2×/week.`,
        warnings: `Doesn't raise GH much; alternate days with Flourish.`,
        targetRange: `Dose to plant need.`,
        sourceUrl: `https://www.seachem.com/flourish-trace.php`,
    },
    'Seachem|Kalkwasser': {
        directions: `3 g (1 tsp) per gal freshwater (6 g/gal for fully saturated); drip clear solution as top-off; hold pH 8.3–8.4.`,
        frequency: `Continuous drip / ATO.`,
        prep: `Dissolve in freshwater only; use clear supernatant; keep lid tight.`,
        warnings: `⚠ Never dose directly/undissolved (pH spike). Don't mix with Ca/alk supplements.`,
        targetRange: `pH 8.3–8.4; 1 gal saturated into 40 gal raises Ca ~24 mg/L.`,
        sourceUrl: `https://seachem.zendesk.com/hc/en-us/articles/115000240173`,
    },
    'Seachem|Marine Buffer™': {
        directions: `5 g per 20 gal dissolved in ≥1 cup freshwater; each dose ≈ +1 meq/L alkalinity; daily until pH stabilizes, then biweekly/monthly.`,
        frequency: `Daily (adjust); biweekly/monthly (maintain).`,
        prep: `Dissolve in ≥1 cup freshwater first.`,
        warnings: `Don't mix with Ca/Mg/Sr supplements; persistent precipitate = do a water change.`,
        targetRange: `pH ceiling 8.3.`,
        sourceUrl: `https://www.seachem.com/marine-buffer.php`,
    },
    'Seachem|Matrix™': {
        directions: `250 mL per 50 gal; any filter (canister ideal); pair with Stability.`,
        frequency: `Permanent; rinse as needed.`,
        prep: `Pre-filter water to reduce clogging.`,
        warnings: `Inert; natural color variation is normal.`,
        targetRange: `Permanent.`,
        sourceUrl: `https://www.seachem.com/matrix.php`,
    },
    'Seachem|MatrixCarbon™': {
        directions: `250 mL per 100 gal; rinse; use in a filter bag; replace every 3–6 months.`,
        frequency: `Every 3–6 months.`,
        prep: `Rinse; bag it; max flow-through.`,
        warnings: `May remove trace elements; don't use in a tumbling reactor; not during Cupramine.`,
        targetRange: `3–6 months.`,
        sourceUrl: `https://www.seachem.com/matrixcarbon.php`,
    },
    'Seachem|Neutral Regulator®': {
        directions: `5 g per 10–20 gal 1–2×/month; daily during initial adjustment.`,
        frequency: `1–2×/month; daily (adjust).`,
        prep: `Dissolve in replacement water ideally.`,
        warnings: `Contains phosphate buffers. Combine with Discus Buffer (lower) or Alkaline Regulator (raise).`,
        targetRange: `pH 7.0.`,
        sourceUrl: `https://www.seachem.com/neutral-regulator.php`,
    },
    'Seachem|ParaGuard™': {
        directions: `Remove inverts + chemical filtration; 5 mL per 10 gal daily; 1-h dip = 3 mL/gal; QT 2 weeks.`,
        frequency: `Daily; dips as needed.`,
        prep: `Remove inverts and chemical filtration (incl. Purigen).`,
        warnings: `Not for reef; don't combine with copper; reduce dose for sensitive fish.`,
        targetRange: `2-week course.`,
        sourceUrl: `https://www.seachem.com/paraguard.php`,
    },
    'Seachem|PhosGuard™': {
        directions: `Pre-wet in 2× volume freshwater, rinse; 85 mL (1/3 cup) per 50 gal SW (100 gal FW); leave 4 days then test.`,
        frequency: `Test at 4 days; replace as PO4 climbs.`,
        prep: `⚠ Pre-wet in FRESHwater (saltwater can boil); don't add water to dry product.`,
        warnings: `Don't use in a tumbling reactor; over-removal stresses corals.`,
        targetRange: `PO4 ~0.02 mg/L.`,
        sourceUrl: `https://www.seachem.com/phosguard.php`,
    },
    'Seachem|Prime®': {
        directions: `1 capful (5 mL) per 50 gal of new water; double for high chloramine; up to 5× for emergency nitrite/nitrate; half dose if >86°F with low chlorine/ammonia.`,
        frequency: `At startup and every water change; re-dose every 24–48 h if needed.`,
        prep: `Best added to new water first; dose tank volume if adding directly.`,
        warnings: `Sulfur smell normal; Nessler kits read false — use salicylate/gas-exchange.`,
        targetRange: `Binds for up to 48 h.`,
        sourceUrl: `https://www.seachem.com/prime.php`,
    },
    'Seachem|Pristine™': {
        directions: `Shake; UV/ozone off; initial 5 mL per 10 gal; maintenance 5 mL per 20 gal with livestock/filter changes.`,
        frequency: `Initial, then as needed.`,
        prep: `Shake; UV/ozone off; remove antibiotics first; restart UV/ozone after 2–3 days.`,
        warnings: `UV/ozone kill bacteria; antibiotics must be removed.`,
        targetRange: `Establishes in 2–3 days.`,
        sourceUrl: `https://www.seachem.com/pristine.php`,
    },
    'Seachem|Reef Advantage Calcium™': {
        directions: `5 g per 150 L raises Ca ~12 mg/L (1 tsp/20 gal ≈ +25 ppm); dissolve in RO/DI first.`,
        frequency: `Daily or as calculated.`,
        prep: `Dissolve in freshwater; don't add dry.`,
        warnings: `Eye irritant; alternate days / ≥30 min from carbonate supplements; max 10 g/150 L/day.`,
        targetRange: `Ca 380–420 mg/L; +12 mg/L per 5 g/150 L.`,
        sourceUrl: `https://www.seachem.com/reef-adv-calcium.php`,
    },
    'Seachem|Reef Advantage Magnesium™': {
        directions: `5 g per 80 L raises Mg ~5 ppm; dissolve in freshwater first.`,
        frequency: `Daily or as calculated.`,
        prep: `Dissolve in freshwater.`,
        warnings: `Severely low Mg (<800) depresses pH; kalkwasser precipitate won't redissolve.`,
        targetRange: `Mg 1200–1350 mg/L.`,
        sourceUrl: `https://www.seachem.com/reef-adv-magnesium.php`,
    },
    'Seachem|Reef Advantage Strontium™': {
        directions: `5 g per 20–40 gal twice a week; advanced: dose to 8–12 mg/L.`,
        frequency: `Twice a week.`,
        prep: `Can add directly (no pre-mix).`,
        warnings: `Excess Sr accelerates alkalinity loss; alternate days from carbonate.`,
        targetRange: `Sr 8–12 mg/L.`,
        sourceUrl: `https://www.seachem.com/reef-adv-strontium.php`,
    },
    'Seachem|Reef Builder™': {
        directions: `3 g (½ tsp) per 40 gal twice a week, dissolved in ≥1 cup freshwater; each 3 g/150 L ≈ +0.25 meq/L; max 12 g/150 L/day. Expert drip: m = 0.08 × v(L) × a(meq/L).`,
        frequency: `Twice a week; test alkalinity every 2 weeks.`,
        prep: `Dissolve in freshwater first.`,
        warnings: `⚠ Don't overdose (drives loss of Ca/Mg/Sr); don't mix with Ca/Mg/Sr; alternate days / ≥30 min apart.`,
        targetRange: `Alkalinity 3–5 meq/L (8–14 dKH).`,
        sourceUrl: `https://www.seachem.com/reef-builder.php`,
    },
    'Seachem|Reef Calcium™': {
        directions: `5 mL per 20 gal twice a week; alone or with ionic calcium for growth.`,
        frequency: `Twice a week.`,
        prep: `Shake occasionally (cold-temp crystals redissolve).`,
        warnings: `Maintenance only — use ionic Ca to correct lows.`,
        targetRange: `Growth at 400–420 ppm (or 370–380 with ionic Ca).`,
        sourceUrl: `https://www.seachem.com/reef-calcium.php`,
    },
    'Seachem|Reef Carbonate™': {
        directions: `5 mL per 20 gal twice a week (dilute in a cup of freshwater first); each 5 mL/80 L ≈ +0.25 meq/L; max 20 mL/80 L/day; don't raise >1 meq/L/day. Expert drip: m = v(L) × a ÷ 4.`,
        frequency: `Twice a week; test every 2 weeks.`,
        prep: `Dilute in freshwater; add near strong flow.`,
        warnings: `⚠ Don't overdose; don't mix with Ca/Mg/Sr; alternate days / ≥30 min apart.`,
        targetRange: `Alkalinity 3–6 meq/L (8–17 dKH).`,
        sourceUrl: `https://seachem.zendesk.com/hc/en-us/articles/115000239933`,
    },
    'Seachem|Reef Complete®': {
        directions: `5 mL per 20 gal twice a week; each 5 mL/80 L ≈ +10 mg/L Ca; max 12.5 mL/80 L/day; don't raise >25 mg/L/day.`,
        frequency: `Twice a week; test every 2 weeks.`,
        prep: `Add directly; alternate days from carbonate.`,
        warnings: `Eye irritant; excess Ca drives alkalinity loss; don't mix with carbonate.`,
        targetRange: `Ca 380–420 mg/L.`,
        sourceUrl: `https://seachem.zendesk.com/hc/en-us/articles/115000460153`,
    },
    'Seachem|Reef Dip™': {
        directions: `Use in a separate container with 1 gal tank water; add 5–10 mL (1–2 caps); dip 15–30 min.`,
        frequency: `As needed (not maintenance).`,
        prep: `Separate container with tank water; watch for excess sliming.`,
        warnings: `⚠ Never use in the main tank.`,
        targetRange: `15–30 min dip.`,
        sourceUrl: `https://www.seachem.com/reef-dip.php`,
    },
    'Seachem|Reef Fusion 1 & 2™': {
        directions: `Shake; every 1–2 days; 1 mL Fusion 1 per 25 L into high flow, wait a few minutes, then 1 mL Fusion 2 per 25 L elsewhere. Each dose ≈ +4 mg/L Ca and +0.176 meq/L alk.`,
        frequency: `Every 1–2 days.`,
        prep: `Shake; add to separate high-flow spots.`,
        warnings: `⚠ Never mix 1 and 2 directly; max 4 mL/25 L/day each; Ca ≤25 mg/L/day, alk ≤1 meq/L/day.`,
        targetRange: `Ca 410–430 mg/L; alk 4–6 meq/L.`,
        sourceUrl: `https://www.seachem.com/reef-fusion.php`,
    },
    'Seachem|Reef Iodide™': {
        directions: `5 mL per 50 gal every other day (≈ +0.2 mg/L iodide); advanced 1 mL/20 gal daily; adjust to 0.06–0.08 mg/L.`,
        frequency: `Every other day (beginner); daily (advanced).`,
        warnings: `⚠ Never use elemental iodine/Lugol's in a reef.`,
        targetRange: `Iodide 0.06–0.08 mg/L.`,
        sourceUrl: `https://seachem.zendesk.com/hc/en-us/articles/115000245034`,
    },
    'Seachem|Reef Phytoplankton™': {
        directions: `Shake; 5 mL per 50 gal twice weekly; dose to the water column (don't target-feed).`,
        frequency: `Twice weekly.`,
        prep: `Shake; refrigerate after opening (recommended).`,
        warnings: `Target feeding can overwhelm corals.`,
        targetRange: `Dose to coral growth.`,
        sourceUrl: `https://www.seachem.com/reef-phytoplankton.php`,
    },
    'Seachem|Reef Plus™': {
        directions: `5 mL per 40 gal twice a week; or food soak (1 mL in ~15 mL frozen food).`,
        frequency: `Twice a week.`,
        prep: `Refrigerate after opening; turn off ozone when dosing.`,
        warnings: `Ozone destroys vitamins/aminos and can make toxic halogens; temporary redox dip is normal.`,
        targetRange: `Dose to coral growth.`,
        sourceUrl: `https://www.seachem.com/reef-plus.php`,
    },
    'Seachem|Reef Strontium™': {
        directions: `5 mL per 80 L (≈20 gal) twice a week; each 5 mL/80 L ≈ +0.6 mg/L; adjust to 8–12 mg/L. Expert drip: m = 0.1 × v(L) × s.`,
        frequency: `Twice a week.`,
        prep: `Add directly.`,
        warnings: `Gluconate has no N/P (won't feed algae).`,
        targetRange: `Sr 8–12 mg/L.`,
        sourceUrl: `https://www.seachem.com/reef-strontium.php`,
    },
    'Seachem|Reef Trace™': {
        directions: `5 mL per 20 gal twice a week; alternate days with Reef Plus.`,
        frequency: `Twice a week.`,
        warnings: `Alternate days with Reef Plus.`,
        targetRange: `Dose on schedule.`,
        sourceUrl: `https://www.seachem.com/reef-trace.php`,
    },
    'Seachem|Reef Zooplankton™': {
        directions: `Shake; 5 mL per 50 gal twice weekly; dose to the water column.`,
        frequency: `Twice weekly.`,
        prep: `Shake; refrigerate after opening (recommended).`,
        warnings: `Target feeding can overwhelm corals.`,
        targetRange: `Dose to coral growth.`,
        sourceUrl: `https://www.seachem.com/reef-zooplankton.php`,
    },
    'Seachem|Safe®': {
        directions: `1.25 g (¼ tsp) per 300 gal (chlorine/chloramine); per 75 gal (ammonia/nitrite). Double for high chloramine; up to 4× emergency nitrite.`,
        frequency: `At startup and every water change.`,
        prep: `Add to new water first; don't pre-mix and store.`,
        warnings: `Don't store in solution (no stabilizers).`,
        sourceUrl: `https://www.seachem.com/safe.php`,
    },
    'Seachem|Stability®': {
        directions: `Shake; UV/ozone off; Day 1 (new): 5 mL per 10 gal; Days 2–7: 5 mL per 20 gal daily; maintenance monthly/with changes.`,
        frequency: `Day 1 double; days 2–7 daily; then monthly.`,
        prep: `Shake; UV/ozone off through the 7-day cycle.`,
        warnings: `UV/ozone kill bacteria; shelf life 4–6 years.`,
        targetRange: `Cycles within ~7 days.`,
        sourceUrl: `https://www.seachem.com/stability.php`,
    },
    'Seachem|StressGuard™': {
        directions: `2.5–5 mL per 10 gal daily until stress/healing resolves; may double.`,
        frequency: `Daily (active ~24 h).`,
        prep: `Turn off skimmer when dosing.`,
        warnings: `⚠ Incompatible with copper meds (incl. Cupramine); reef/planted safe as directed.`,
        targetRange: `Active ~24 h; dose until healed.`,
        sourceUrl: `https://www.seachem.com/stressguard.php`,
    },
    // ── Tetra ──────────────────────────────────────────────────────────────────
    'Tetra|AquaSafe® Plus': {
        directions: `Shake; 5 mL (1 tsp) per 10 gal (cap inner ring = 10 gal, full cap = 20 gal); match water temperatures.`,
        frequency: `Setup, water changes, top-off.`,
        prep: `Shake; match temperature.`,
        warnings: `Not a medication; store cool/dark.`,
        sourceUrl: `https://www.tetra-fish.com/products/water-care/aquasafe-plus`,
    },
    'Tetra|EasyBalance® Plus': {
        directions: `Shake; 5 mL per 10 gal weekly.`,
        frequency: `Weekly.`,
        prep: `Shake; ensure good aeration.`,
        warnings: `NOT a dechlorinator — still use AquaSafe with tap water; don't use in low-oxygen tanks.`,
        targetRange: `Cuts large water changes to ~every 6 months.`,
        sourceUrl: `https://www.tetra-fish.com/products/water-care/easybalance-plus`,
    },
    'Tetra|SafeStart® Plus': {
        directions: `New tank: add the entire bottle (tanks up to 100 gal). Maintenance (adding fish / after water changes / media changes): 5 mL per 10 gal.`,
        frequency: `Full bottle at setup; then as needed.`,
        prep: `Condition tap water with AquaSafe first; keep temperature stable.`,
        warnings: `Don't freeze/overheat.`,
        targetRange: `Fish can be added immediately after dosing.`,
        sourceUrl: `https://www.tetra-fish.com/products/water-care/safestart-plus-3-38-oz`,
    },
    'Tetra|AlgaeControl™': {
        directions: `Clean visible algae first; remove carbon 6–8 h; 1 mL per 12 gal into high flow (or pre-dilute); repeat every 3 days up to 3 doses, then clean + water change.`,
        frequency: `Every 3 days up to 3 doses.`,
        prep: `Remove carbon 6–8 h; good aeration; apply in the morning.`,
        warnings: `⚠ Federal pesticide — don't overdose; not for tanks <3 months old; not with inverts/crustaceans; eye irritant.`,
        targetRange: `Up to 3 doses; 3-month tank minimum.`,
        sourceUrl: `https://www.tetra-fish.com/products/water-care/algaecontrol`,
    },
    'Tetra|Lifeguard®': {
        directions: `Remove carbon; UV off; 1 tablet per 5 gal daily ×5 days; Day 6 restore carbon/UV + 25% water change.`,
        frequency: `Once daily ×5 days.`,
        prep: `Remove carbon; UV off; keep other filtration running.`,
        warnings: `⚠ Eye irritant; not for scaleless fish, inverts, or new tanks.`,
        targetRange: `5-day course.`,
        sourceUrl: `https://www.tetra-fish.com/products/water-care/lifeguard-tablets`,
    },
    // ── Tropic Marin ───────────────────────────────────────────────────────────
    'Tropic Marin|All-For-Reef': {
        directions: `Liquid: start 5 mL per 26 gal/day; increase 2.5 mL/26 gal weekly to match consumption; max 25 mL/26 gal/day. Powder: dissolve 6 scoops in 1 L RO/DI first.`,
        frequency: `Daily; ramp weekly.`,
        prep: `Powder: dissolve first; liquid: shake. Test alkalinity every 2–3 days while ramping.`,
        warnings: `Ramp gradually (2.5 mL/26 gal/week max).`,
        targetRange: `Ca 420–450, KH 8–10 dKH, Mg 1250–1350.`,
        sourceUrl: `https://tropic-marin-smartinfo.com`,
    },
    'Tropic Marin|Original Balling System (Part A, B, C)': {
        directions: `Dissolve each in RO/DI separately; dose equal amounts of A, B, C daily into different sump areas; never mix. ~30 mL each per 10 gal ≈ +15 ppm Ca and +2.2 dKH; max 60 mL each/10 gal/day.`,
        frequency: `Daily; adjust to consumption.`,
        prep: `Dissolve separately; label; dose into different areas.`,
        warnings: `⚠ Never mix A/B/C before dosing.`,
        targetRange: `Ca 390–450, KH 7–10 dKH, Mg 1200–1400.`,
        sourceUrl: `https://tropic-marin-smartinfo.com/original-balling-components`,
    },
    'Tropic Marin|Carbo-Calcium': {
        directions: `Start 5 mL per 26 gal/day; increase 2.5 mL/26 gal weekly; max 25 mL/26 gal/day. Dissolve powder form in RO/DI first.`,
        frequency: `Daily; ramp weekly.`,
        prep: `Dissolve powder in RO/DI; test Ca/alk every 2–3 days.`,
        warnings: `Ramp gradually.`,
        targetRange: `Alk 7–9 dKH; Ca 390–450.`,
        sourceUrl: `https://tropic-marin-smartinfo.com/carbocalcium`,
    },
    'Tropic Marin|Bio-Magnesium': {
        directions: `1 level spoon (~5 g) per ~26–29 gal raises Mg ~10 ppm; max 2 spoons per 110 L/day.`,
        frequency: `Daily (building) / weekly (maintain).`,
        prep: `Can dose directly into high flow (no pre-mix needed).`,
        warnings: `Don't raise Mg >50 ppm/day.`,
        targetRange: `Mg 1200–1350.`,
        sourceUrl: `https://www.tropicmarin.com/products/bio-magnesium`,
    },
    'Tropic Marin|Nitribiotic': {
        directions: `Initial 1 mL per 26 gal; maintenance 1 mL per 52 gal weekly; add to filter/sump.`,
        frequency: `At startup; weekly maintenance.`,
        prep: `UV/ozone/skimmer off; restart 3–4 h after dosing.`,
        warnings: `UV/ozone/skimmer kill bacteria; not with copper/oxidizers; refrigerate, don't freeze.`,
        targetRange: `Done when NH3/NO2 = 0.`,
        sourceUrl: `https://www.tropicmarin.com/products/nitribiotic`,
    },
    // ── Two Little Fishies ─────────────────────────────────────────────────────
    'Two Little Fishies|C-Balance 2-Part': {
        directions: `Start 5 mL of each per 20 gal/day; max 1 mL each per gallon/day (split into 2–3 doses near max). Dose A and B separately; rinse the cap between. (2-gal concentrate: fill to line with RO/DI first.)`,
        frequency: `Daily; increase ≤2.5 mL/20 gal per week.`,
        prep: `Fill concentrate with RO/DI; dose parts separately into high flow; rinse cap between.`,
        warnings: `⚠ Never mix A and B (instant precipitation).`,
        targetRange: `Alk 2.5–3.5 meq/L (7–10 dKH); Ca 380–450 ppm.`,
        sourceUrl: `https://www.seaflowerstore.com/collections/two-little-fishies`,
    },
};
//# sourceMappingURL=commercial-products-info.js.map